import { assets } from './assets.const';

export interface sidebarInterface {
  text: string,
  path?: string,
  img?: string,
  isSubMenu: boolean,
  subMenuItems?: sidebarInterface[]
}
export const sideBar: sidebarInterface[] = [
  {
    text: 'Dashboard',
    path: '/dashboard',
    img: assets.sidebarDashboardIcon,
    isSubMenu: false
  },
  // {
  //   text: 'Xplora Booking Management',
  //   path: '/voucher-management',
  //   img: assets.VoucherIcon,
  //   isSubMenu: false
  // },
  {
    text: 'Xplora Booking Management',
    path: '/bookings',
    img: assets.bookingIcon,
    isSubMenu: false
  },
  {
    text: 'Xplora Custom Booking Management',
    path: '/custom-bookings',
    img: assets.bookingIcon,
    isSubMenu: false
  },
  {
    text: 'Manage Package',
    path: '/packages',
    img: assets.packageIcon,
    isSubMenu: false
  },
  {
    text: 'Categories',
    path: '/services',
    img: assets.serviceIcon,
    isSubMenu: false
  },
  {
    text: 'AD Banner Management',
    path: 'ad-banner',
    img: assets.AdIcon,
    isSubMenu: false
  },
  {
    text: 'Deal Management',
    path: '/deals',
    img: assets.dealIcon,
    isSubMenu: false
  },
  // {
  //   text: 'Request Slot Change',
  //   path: '/slot-management',
  //   img: assets.CategoryIcon,
  //   isSubMenu: false
  // },
  {
    text: 'Manage Reviews',
    path: '/review',
    img: assets.ReveiwIcon,
    isSubMenu: false
  }
  // {
  //   text: 'Manage Payment',
  //   path: '/revenue',
  //   img: assets.RevenueIcon,
  //   isSubMenu: false
  // },
  // {
  //   text: 'Manage Settings',
  //   path: '/cms',
  //   img: assets.settingIcon,
  //   isSubMenu: false
  // },
  // {
  //   text: 'Report Management',
  //   path: '/reports',
  //   img: assets.ReportIcon,
  //   isSubMenu: false
  // }
];
